/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { ActivityType } from 'src/app/_model/activity-type';

@Injectable()
export abstract class ActivityTypesDaoService implements Resetable {
  public abstract saveActivityTypes(
    activityTypes: ActivityType[]
  ): Promise<void>;
  public abstract getActivityTypes(): Promise<ActivityType[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
